const app = {
    state:{
        collapsed:false ,
      collapsedbar: true
    },
    mutations: {
        SET_COLLAPSED: (state, collapsed) => {
            state.collapsed = collapsed
        },
      SET_COLLAPSEDBAR: (state, collapsedbar) => {
        state.collapsedbar = collapsedbar
      }
    },
    actions: {
        updateCollapsed({commit},collapsed){
            commit('SET_COLLAPSED',collapsed)
        },
      updateCollapsedbar({commit}, collapsedbar) {
        commit('SET_COLLAPSEDBAR', collapsedbar)
      }
    }
}

export default app;
